<template>
  <div class="campos-custom">
    <div v-for="campo in campos" :key="campo.key" class="form-row">
      <label class="label">
        {{ campo.label }}<span v-if="campo.obrigatorio" class="req">*</span>
      </label>

      <input v-if="campo.tipo === 'text'"
             class="input" type="text"
             :placeholder="campo.placeholder || ''"
             :value="modelValue[campo.key] || ''"
             @input="setVal(campo.key, $event.target.value)" />

      <input v-else-if="campo.tipo === 'number'"
             class="input" type="number"
             :min="campo.min"
             :max="campo.max"
             :placeholder="campo.placeholder || ''"
             :value="modelValue[campo.key] ?? ''"
             @input="setVal(campo.key, $event.target.value === '' ? null : Number($event.target.value))" />

      <textarea v-else-if="campo.tipo === 'textarea'"
                class="textarea" rows="3"
                :placeholder="campo.placeholder || ''"
                :value="modelValue[campo.key] || ''"
                @input="setVal(campo.key, $event.target.value)"></textarea>

      <!-- Poucas opcoes viram cartoes clicaveis: um toque em vez de abrir o
           dropdown nativo, e da pra ver todas as escolhas de uma vez. -->
      <div v-else-if="campo.tipo === 'select' && (campo.opcoes || []).length <= 4"
           class="opcao-cards" role="radiogroup" :aria-label="campo.label">
        <button v-for="op in campo.opcoes" :key="op"
                type="button"
                class="opcao-card"
                :class="{ active: modelValue[campo.key] === op }"
                role="radio"
                :aria-checked="modelValue[campo.key] === op"
                @click="setVal(campo.key, op)">
          <span v-if="corDaOpcao(op)" class="opcao-bolinha" :style="{ background: corDaOpcao(op) }"></span>
          <span class="opcao-nome">{{ op }}</span>
          <span class="opcao-check" aria-hidden="true">✓</span>
        </button>
      </div>

      <select v-else-if="campo.tipo === 'select'"
              class="select"
              :value="modelValue[campo.key] || ''"
              @change="setVal(campo.key, $event.target.value)">
        <option value="" disabled>Selecione...</option>
        <option v-for="op in campo.opcoes" :key="op" :value="op">{{ op }}</option>
      </select>

      <input v-else-if="campo.tipo === 'date'"
             class="input" type="date"
             :value="modelValue[campo.key] || ''"
             @input="setVal(campo.key, $event.target.value)" />

      <label v-else-if="campo.tipo === 'checkbox'" class="check-row">
        <input type="checkbox"
               :checked="!!modelValue[campo.key]"
               @change="setVal(campo.key, $event.target.checked)" />
        <span>{{ campo.placeholder || campo.label }}</span>
      </label>

      <span v-if="errors[campo.key]" class="error-msg">{{ errors[campo.key] }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CamposCustomForm',
  props: {
    campos: { type: Array, default: () => [] },
    modelValue: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) }
  },
  emits: ['update:modelValue'],
  methods: {
    /**
     * Opcao cujo nome e uma cor ganha um marcador colorido. Serve pra times e
     * equipes; qualquer outro texto cai fora e o cartao fica so com o rotulo.
     */
    corDaOpcao(op) {
      const nome = String(op).toLowerCase().trim()
      const base = nome.replace(/[ao]$/, '')
      return {
        amarel: '#F0B429',
        azul: '#2F6FED',
        verde: '#2BA24C',
        pret: '#2B2F36',
        branc: '#E8E3D9',
        vermelh: '#D6453D',
        rox: '#7C4DBE',
        laranj: '#E2703A',
        ros: '#D9578E'
      }[base] || null
    },
    setVal(key, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value })
    }
  }
}
</script>

<style scoped>
.campos-custom { display: flex; flex-direction: column; gap: var(--spacing-md); }
.form-row { display: flex; flex-direction: column; gap: 4px; }
.req { color: var(--color-danger); margin-left: 2px; }
.check-row { display: flex; align-items: center; gap: 8px; font-size: var(--text-sm); cursor: pointer; }

.opcao-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
}
.opcao-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1.5px solid var(--color-border, #d9d4c9);
  border-radius: 10px;
  background: var(--color-surface, #fff);
  font: inherit;
  font-size: var(--text-sm);
  color: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
@media (hover: hover) {
  .opcao-card:hover { border-color: var(--color-primary, #8a6d3b); }
}
.opcao-card:focus-visible {
  outline: 2px solid var(--color-primary, #8a6d3b);
  outline-offset: 2px;
}
.opcao-card.active {
  border-color: var(--color-primary, #8a6d3b);
  box-shadow: inset 0 0 0 1px var(--color-primary, #8a6d3b);
  background: var(--color-primary-soft, rgba(138, 109, 59, 0.07));
}
.opcao-bolinha {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.18);
}
.opcao-nome { flex: 1 1 auto; }
.opcao-check {
  flex: 0 0 auto;
  font-size: 13px;
  color: var(--color-primary, #8a6d3b);
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.opcao-card.active .opcao-check { opacity: 1; transform: scale(1); }
</style>
